import { action, makeObservable, observable } from 'mobx';

export interface IExtensionResponse {
    alertId: string;
    createdOn: Date;
    endedOn: Date;
    extensionId: string;
    extensionName: string;
    extensionVersionId: string;
    filename: string;
    hostId: string;
    hostname: string;
    id: string;
    ip: string;
    name: string;
    output: {
        output: any[];
        executionSummary: string;
    };
    outputString: string;
    startedOn: string;
    status: string;
    success: true;
    userId: string;
    email: string;
}

export default class extensionResponseStore {
    extensionResponse = {
        name: '',
        extensionName: '',
        hostname: '',
        status: '',
        email: ''
    };

    constructor(extensionResponse: IExtensionResponse) {
        this.update(extensionResponse);

        makeObservable(this, {
            extensionResponse: observable,
            update: action
        });
    }

    update(extensionResponse: IExtensionResponse): void {
        this.extensionResponse = {
            ...this.extensionResponse,
            ...extensionResponse
        };
    }
}
